// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"XY-z","sponsoredTooltipWrapper":"YY-z","sponsoredTooltip":"ZY-z","newCard":"_Y-z"};